// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--2D9w1","noBorder":"button-module--no-border--3Cosw"};